import React, { useState } from 'react'
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails, Theme, Button, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ModerRequestModal } from '../modals/moder-request'
import { N1RequestAll } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const Employees: React.FC<{
  img: any
  full?: boolean
  className: any
  expanded: boolean
  updateInfo(): void
  onExpand: () => void
  data: N1RequestAll[]
}> = ({ data = [], full = false, updateInfo, className, img = [], expanded, onExpand = () => {} }): JSX.Element => {
  const classes = useStyles()

  const mdDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))
  const smDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [moderRequestModal, setModerRequestModal] = useState<boolean>(false)
  const [confirm, setConfirm] = useState<{ id: number; type: boolean }>({ id: 0, type: true })

  return (
    <>
      {full && (
        <ModerRequestModal
          id={confirm.id}
          confirm={confirm.type}
          updateInfo={updateInfo}
          show={moderRequestModal}
          onClose={() => setModerRequestModal(false)}
        />
      )}

      <Box className={classes.employees}>
        <Accordion id="employees" square={false} expanded={expanded} onChange={onExpand}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Сотрудники</AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetails}>
              {full ? (
                data.map((k: N1RequestAll, i: number) => {
                  return (
                    <Box key={`employees-${i}`} className={classes.employeesItem} pb={1}>
                      <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                        <Grid item xs={6} sm={8}>
                          <Box className={classes.employeesName}>
                            {k.command.users[0].lastName} {k.command.users[0].firstName} {k.command.users[0].middleName}
                          </Box>
                        </Grid>

                        <Grid item xs={6} sm={4}>
                          {k.nomination ? (
                            <Box className={classes.employeesTeams} textAlign="right">
                              «{k.nomination.name}»
                            </Box>
                          ) : (
                            <Box textAlign="right"> -</Box>
                          )}
                        </Grid>
                      </Grid>

                      {!k && <Box className={classes.employeesStatus}>Заявка не подана</Box>}
                      {k.status && (
                        <>
                          {k.status !== 'NEW' && <Box className={classes.employeesStatus}>{k.statusName}</Box>}

                          {k.status === 'NEW' && (
                            <Box className={classes.employeesConfirm}>
                              <Grid
                                container
                                wrap="nowrap"
                                justifyContent={smDown ? 'center' : 'flex-start'}
                                spacing={mdDown ? 1 : 2}
                              >
                                <Grid item>
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.btn}
                                    onClick={() => {
                                      setConfirm({
                                        id: k.id,
                                        type: true,
                                      })
                                      setModerRequestModal(true)
                                    }}
                                  >
                                    Подтвердить заявку
                                  </Button>
                                </Grid>
                                <Grid item>
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.btnReject}
                                    onClick={() => {
                                      setConfirm({
                                        id: k.id,
                                        type: false,
                                      })
                                      setModerRequestModal(true)
                                    }}
                                  >
                                    Отклонить заявку
                                  </Button>
                                </Grid>
                              </Grid>
                            </Box>
                          )}
                        </>
                      )}
                    </Box>
                  )
                })
              ) : (
                <Box my={2}>
                  {data.map((k: N1RequestAll, i: number) => {
                    return (
                      <Box key={`employees-${i}`} className={classes.employeesItem}>
                        <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center" spacing={2}>
                          <Grid item xs={6} sm={8}>
                            <Box className={classes.employeesNameRead}>
                              {k.command.users[0].lastName} {k.command.users[0].firstName}{' '}
                              {k.command.users[0].middleName}
                            </Box>
                          </Grid>
                          {!k.statusName && (
                            <Grid item xs={6} sm={4}>
                              <Box className={classes.employeesStatus}>Заявка не подана</Box>
                            </Grid>
                          )}
                          {k.nomination && (
                            <Grid item xs={6} sm={4}>
                              <Box className={classes.employeesNameRead} textAlign="right">
                                «{k.nomination.name}»
                              </Box>
                              <Box className={classes.employeesStatus}>{k.statusName}</Box>
                            </Grid>
                          )}
                        </Grid>
                      </Box>
                    )
                  })}
                </Box>
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  employees: {},
  employeesItem: {
    marginBottom: 10,
  },
  employeesName: {
    fontSize: 16,
    paddingRight: 15,
    fontWeight: 500,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  employeesTeams: {
    fontSize: 16,
    fontWeight: 500,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  employeesStatus: {
    textAlign: 'right',
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  employeesConfirm: {
    marginTop: 15,
    marginBottom: 15,
    [down('md')]: {
      marginTop: 10,
      marginBottom: 10,
    },
  },
  employeesNameRead: {
    color: palette.text.secondary,
    fontWeight: 500,
    marginTop: 3,
    fontSize: 18,
    [down('md')]: {
      fontSize: 17,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
    },
    [down('sm')]: {
      fontSize: '11px!important',
      padding: '10px 12px!important',
      minHeight: '25px!important',
      minWidth: '10px!important',
    },
  },
  btnReject: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    color: `${palette.primary.dark}!important`,
    backgroundColor: '#6C6C6C!important',
    '&:hover': {
      color: `${palette.text.primary}!important`,
      backgroundColor: `#5b5b5b!important`,
    },
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
    },
    [down('sm')]: {
      fontSize: '11px!important',
      padding: '10px 12px!important',
      minHeight: '25px!important',
      minWidth: '10px!important',
    },
  },
}))
